







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoDialogRegeln extends Vue {}
